import { render, staticRenderFns } from "./listpeserta.vue?vue&type=template&id=5563ce3b&"
import script from "./listpeserta.vue?vue&type=script&lang=js&"
export * from "./listpeserta.vue?vue&type=script&lang=js&"
import style0 from "./listpeserta.vue?vue&type=style&index=0&id=5563ce3b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports